import { FileField, FileFieldProps } from '@components/file-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFileFieldProps<T> = FormFieldProps<FileFieldProps, T>;

export function FormFileField<T>(props: FormFileFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'file' });

  return <FileField {...props} {...formFieldProps} />;
}
